export default "__VITE_ASSET__d3af9d17__"